
import React, { FC, useEffect, useState, useRef } from 'react';
import { Input } from 'antd';
import { getOpenApiData } from '@/common/asset-apis/assetModel';
import { COLUMN_FROM } from '../../effects/consts';
import { useUpdateEffect, useDebounceEffect } from 'ahooks';
import memo from '../memo';
import { cloneDeep } from 'lodash';

interface OpenApiInputProps {
  API: {
    FetchAPI?: any;
  };
  field: any;
  value?: string;
  onChange?: Function;
  form: any;
  config: Record<any, any>;
  columnFrom: any;
  storeValue: any;
  rowsData: any;
  disabled?: boolean;
  allowClear?: boolean;
  moduleInfo: any;
}

export const OpenApiInput: FC<OpenApiInputProps> = ({
  API,
  field,
  value,
  onChange,
  form,
  config,
  columnFrom,
  storeValue,
  disabled,
  rowsData,
  allowClear,
  moduleInfo,
}) => {
  const { dispatchEvent, destroyEvent, taskInfo } = config.metaStore || {};
  const [apiParamsList, setapiParamsList] = useState({});
  const { apiUrl, apiKeyList, apiType = 'get', ruleField, saveField } = field?.bizConfig || {};
  const ref = useRef({});

  useEffect(() => {
    let headData: Record<any, any> = {};
    if (storeValue) {
      Object.keys?.(storeValue)?.forEach((key: any) => {
        if (!Array.isArray(storeValue[key])) {
          headData = storeValue[key];
        }
      });
    }

    if (columnFrom === COLUMN_FROM.TABLE) {
      if (rowsData?.[config.rowIndex]) {
        apiKeyList.forEach((item: any) => {
          if (item.isValueFromMainModule) {
            ref.current = { ...ref.current, [item.apiKey]: headData?.[item.apiValueModule] };
          } else {
            ref.current = { ...ref.current, [item.apiKey]: rowsData?.[config.rowIndex]?.[item.apiValue] };
          }
        });
      }
    }
    if (columnFrom === COLUMN_FROM.FORM) {
      apiKeyList.forEach((item: any) => {
        if (item.isValueFromMainModule) {
          ref.current = { ...ref.current, [item.apiKey]: headData?.[item.apiValueModule] };
        } else {
          ref.current = { ...ref.current, [item.apiKey]: config.formValue[item.apiValue] };
        }
      });
    }
    const mainModuleCode = taskInfo?.modules?.find(
      (module: any) => module.moduleID === taskInfo?.mainModuleId,
    )?.handle;
    const idList: any[] = [];
    const events: any = [];
    apiKeyList?.forEach((item: any) => {
      events.push({
        code: field.name,
        name: field.label,
        touchConfig: 'change',
        actionType: 'callback',
        moduleName: item.isValueFromMainModule ? mainModuleCode : moduleInfo.handle,
        fieldName: item.isValueFromMainModule ? item.apiValueModule : item.apiValue,
        rowIndex: config.rowIndex,
        fun: (value: any) => {
          // const cloneList: Record<any, any> = cloneDeep(apiParamsList);
          // cloneList[item.apiKey] = value;
          // setapiParamsList(cloneList);
          ref.current = { ...ref.current, [item.apiKey]: value };
          setapiParamsList({ ...ref.current, [item.apiKey]: value });
          // const pass = Object.keys(ref.current).every((key: string) => ref.current[key]);
          // if (pass) {
          //   getOpenApiData(API.FetchAPI, apiType, apiUrl, ref.current).then((res: any) => {
          //     onChange?.(res?.[saveField]);
          //   });
          // } else {
          //   setTimeout(() => {
          //     onChange?.('');
          //   }, 100);
          // }
        },
      });
    });
    const ids = dispatchEvent?.(events);
    idList.push(ids);
    return () => {
      idList?.forEach((ids: any) => {
        destroyEvent?.(ids);
      });
    };
  }, []);

  // 忽略第一次加载，后续变更覆盖值
  useUpdateEffect(() => {
    const pass = apiKeyList.every((item: any) => ref.current[item.apiKey]);
    if (pass) {
      getOpenApiData(API.FetchAPI, apiType, apiUrl, ref.current).then((res: any) => {
        onChange?.(res?.[saveField]);
      });
    } else {
      setTimeout(() => {
        onChange?.('');
      }, 100)
    }
  }, [JSON.stringify(ref.current)]);


  return (
    <Input value={value} disabled={disabled} onChange={(e) => onChange?.(e.target.value)} allowClear={allowClear !== false} />
  );
};

export const OpenApiInputMemo = memo(OpenApiInput);
